import React, { useState, useEffect } from 'react';
import HelpTogal from '../TogelButton/HelpTogal';
import PurchaseServices from '../../services/PurchaseServices.js';

function UpdateCoupan({ data, closeModal, onSuccess }) {

  const [formValues, setFormValues] = useState({
    itemName: '',
    amount: '',
    image: '',
    vendorName: '',
    vendorContact: '',
    description: '',
    vendorAddress: '',
    date: '', 
  });

  useEffect(() => {
    if (data) {
      console.log("Received data:", data); 
  
      const formattedDate = data?.date
        ? new Date(data.date).toISOString().split('T')[0] 
        : '';
  
      setFormValues({
        itemName: data?.itemName || '',
        amount: data?.amount || '',
        image: data?.image || '',
        vendorName: data?.vendorDetails?.name || '',
        vendorContact: data?.vendorDetails?.contact || '',
        vendorAddress: data?.vendorDetails?.address || '',
        description: data?.description || '',
        date: formattedDate, // Ensure date is properly formatted
      });
    }
  }, [data]);
  
  
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      await PurchaseServices.updatePurchases(data.id, formValues);
      alert('Addons updated successfully');
      onSuccess();
      closeModal();
    } catch (error) {
      console.error('Failed to update addons', error);
      alert('Failed to update addons');
    }
  };


  return (
    <div className="modal fade edit-box show d-block" id="editModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Addons Edit</h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" onClick={closeModal} aria-label="Close" />
          </div>
          <div className="modal-body">
            <div className="container-box px-5">
              <div className="container-box-inner table-reponsive-tabe">
                <div className="page-details">
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-md-4">
                        <div className="input-field">
                          <label>Item Name</label>
                          <input type="text" name="itemName" className="form-control" value={formValues.itemName} onChange={handleInputChange} placeholder="itemName"/>
                        </div>
                      </div>

                      <div className="col-md-4">
                        <div className="input-field">
                          <label>Amount</label>
                          <input type="text" name="amount" className="form-control" value={formValues.amount} onChange={handleInputChange} placeholder="Price"/>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="input-field">
                          <label>vendorName</label>
                          <input type="text" name="vendorName" className="form-control" value={formValues.vendorName} onChange={handleInputChange} placeholder="description"/>
                        </div>
                      </div>

                      
                      <div className="col-md-6">
                        <div className="input-field">
                          <label>vendorContact</label>
                          <input type="text" name="vendorContact" className="form-control" value={formValues.vendorContact} onChange={handleInputChange} placeholder="description"/>
                        </div>
                      </div>
                   

                      <div className="col-md-6">
                        <div className="input-field">
                          <label>description</label>
                          <input type="text" name="description" className="form-control" value={formValues.description} onChange={handleInputChange} placeholder="description"/>
                        </div>
                      </div>

                      
                      <div className="col-md-4">
                        <div className="input-field">
                          <label>vendorAddress
                          </label>
                          <input type="text" name="vendorAddress" className="form-control" value={formValues.vendorAddress
                          } onChange={handleInputChange} placeholder="vendorAddress"/>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="input-field">
                          <label>Date<span className="red">*</span></label>
                          <input type="date" name="date" className="form-control" value={formValues.date} onChange={handleInputChange}/>
                        </div>
                      </div>


                    </div>
                    <button className="submit-green-btn">Submit</button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UpdateCoupan;
